// Import package components
import { useContext, useMemo } from "react";
import {
  Switch,
  Route,
  useRouteMatch,
} from "react-router-dom";

import { AppContexts } from "../../providers";

import AuthorizedRoute from "../../authorized-route";

import WorkOrderList from "./work_order_list";
import WorkOrderUpdate from "./work_order_update";
import WorkOrderCalendar from "./work_order_calendar";

const EMPTY_CONFIG = {};

const WorkOrder = ({ listConfig = EMPTY_CONFIG }) => {
  const { path } = useRouteMatch();
  const { user } = useContext(AppContexts.AuthContext);
  const showCalendar = listConfig.showCalendar === true;

  const idRegEx = "[0-9]+";
  const uuidRexEx =
    "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";

  // Stable component identity so React Router does not unmount/remount
  // WorkOrderList on every WorkOrder re-render. Without this the route
  // tears down and re-creates the list every render, causing infinite
  // fetch/history.replace loops.
  const ListRoute = useMemo(
    () => (props) => <WorkOrderList {...props} config={listConfig} />,
    [listConfig],
  );

  return (
    <Switch>
      {user && (
        <AuthorizedRoute exact path={path} component={ListRoute} />
      )}
      {user && showCalendar && (
        <AuthorizedRoute
          exact
          path={`${path}/calendar`}
          component={WorkOrderCalendar}
        />
      )}
      {user && (
        <AuthorizedRoute
          path={`${path}/:slug(${uuidRexEx})/:id(${idRegEx})`}
          component={WorkOrderUpdate}
        />
      )}
      {user && (
        <AuthorizedRoute
          exact
          path={`${path}/:slug(${uuidRexEx})`}
          component={ListRoute}
        />
      )}
      {user && (
        <AuthorizedRoute
          path={`${path}/:id(${idRegEx})`}
          component={WorkOrderUpdate}
        />
      )}
      {!user && (
        <Route
          path={`${path}/:slug(${uuidRexEx})/:id(${idRegEx})`}
          component={WorkOrderUpdate}
        />
      )}
      {!user && (
        <Route
          exact
          path={`${path}/:slug(${uuidRexEx})`}
          component={ListRoute}
        />
      )}
    </Switch>
  );
};

export default WorkOrder;
